import { createBrowserRouter } from "react-router-dom";
import { EmbeddedRoot } from "@/surfaces/embedded/embedded-root";
import { embeddedRoutes } from "@/surfaces/embedded/routes";
import { standaloneRoutes } from "@/surfaces/standalone/routes";
import { StandaloneRoot } from "@/surfaces/standalone/standalone-root";
import { EMBEDDED_ROUTE_PREFIX } from "@/surfaces/surface";
import RouterErrorBoundary from "./router-error-boundary";

/**
 * 两个 surface 并列在路由根；认证边界只挂在 standalone 分支。
 * `/embedded` 更具体，会优先于 standalone 内的 `*` 兜底。
 */
export const appRouter = createBrowserRouter([
  {
    path: EMBEDDED_ROUTE_PREFIX,
    element: <EmbeddedRoot />,
    errorElement: <RouterErrorBoundary />,
    children: embeddedRoutes,
  },
  {
    Component: StandaloneRoot,
    errorElement: <RouterErrorBoundary />,
    children: standaloneRoutes,
  },
]);
